import { useMedia } from 'hooks/useMedia'
import { SectionsList } from './styled'
import { breakpoints } from 'styles/mq'
import { FC } from 'react'
import { Chapters } from 'models'

type Props = {
  sections: Chapters[number]['sections']
  onClick: (section: HTMLElement) => void
}

export const Sections: FC<Props> = ({ sections, onClick }) => {
  const isMobile = useMedia([breakpoints.smallOnly], [true], false)

  return (
    <SectionsList
      {...(isMobile
        ? null
        : {
            initial: { height: 0, opacity: 0 },
            animate: { height: 'auto', opacity: 1 },
            exit: { height: 0, opacity: 0 },
          })}
    >
      {sections.map(section => (
        <li
          key={section.title}
          data-title={section.title}
          {...(section.hidden ? { 'data-hidden': true } : null)}
        >
          <button
            type="button"
            disabled={section.isActive}
            onClick={() => onClick(section.element)}
          >
            {section.title}
          </button>
        </li>
      ))}
    </SectionsList>
  )
}
